module.exports = __webpack_public_path__ + "img/icon_wy07.47af80e2.png";